<mat-table [dataSource]="parentMeetingSlots">
  <ng-container matColumnDef="date">
    <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
    <mat-cell *matCellDef="let slot; let i = index">
      <span [attr.data-cy]="'parent-meeting-slot-date-' + i">{{slot.startTime | date:
      isMobile?'dd/MM':'dd/MM/yyyy'}}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="hour">
    <mat-header-cell *matHeaderCellDef>Heure</mat-header-cell>
    <mat-cell *matCellDef="let slot; let i = index">
      <span [attr.data-cy]="'parent-meeting-slot-hour-' + i">{{slot.startTime | date: 'HH:mm'}}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="student">
    <mat-header-cell *matHeaderCellDef>Élève</mat-header-cell>
    <mat-cell *matCellDef="let slot; let i = index" [attr.data-cy]="'parent-meeting-slot-student-' + i">
      {{slot.concernedStudentLastName}} {{slot.concernedStudentFirstName}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="teacher">
    <mat-header-cell *matHeaderCellDef>Enseignant</mat-header-cell>
    <mat-cell *matCellDef="let slot; let i = index" [attr.data-cy]="'parent-meeting-slot-teacher-' + i">
      {{slot.scheduledByStaffMemberLastName}} {{slot.scheduledByStaffMemberFirstName | slice:0:1}}.
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let slot; let i = index">
      @if (slot.bookableSlot && !slot.booked && !alreadyBooked) {
        <button mat-icon-button
          (click)="bookParentMeetingSlot(slot)" [attr.data-cy]="'parent-meeting-slot-book-btn-' + i">
          <mat-icon>alarm_on</mat-icon>
        </button>
      }
      @if (slot.bookableSlot && slot.booked && !!slot.concernedStudentId) {
        <button mat-icon-button
          (click)="unbookParentMeetingSlot(slot)" [attr.data-cy]="'parent-meeting-slot-unbook-btn-' + i">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns; let entry"
    [ngClass]="{'locked': (!row.bookableSlot || row.booked) && !readonly, 'booked-by-me': (row.booked && !!row.concernedStudentId) && !readonly}">
  </mat-row>
</mat-table>